import { LotItemManufacturerLotGroup } from '@app/models/inventory/lot-item-manufacturer-lot-group';
import { SITE_ID_PRIDE_CHEMICALS, SITE_ID_SIERRA } from '@app/models/site/site-ids';

export interface AvailableInventoryWarehouse {
  locationCode: string;
  labelKey: string;
  fallbackLabel: string;
}

export interface AvailableInventoryRow extends LotItemManufacturerLotGroup {
  warehouse: AvailableInventoryWarehouse;
}

const PRODUCTION_LABEL = { labelKey: 'Client_PO_AvailableInventory_Production', fallbackLabel: 'Production' };
const FINISHED_GOODS_LABEL = { labelKey: 'Client_PO_AvailableInventory_FinishedGoods', fallbackLabel: 'Finished Goods' };

// Inventory.API identifies warehouses by code only; Northern Textiles has no production warehouse.
const WAREHOUSES_BY_SITE: Record<string, AvailableInventoryWarehouse[]> = {
  [SITE_ID_PRIDE_CHEMICALS]: [
    { locationCode: 'PC.WH-PROD-1', ...PRODUCTION_LABEL },
    { locationCode: 'PC.WH-FG-1', ...FINISHED_GOODS_LABEL },
  ],
  [SITE_ID_SIERRA]: [{ locationCode: 'NT.WH-FG-1', ...FINISHED_GOODS_LABEL }],
};

export function getAvailableInventoryWarehouses(siteId: string): AvailableInventoryWarehouse[] {
  return WAREHOUSES_BY_SITE[siteId] ?? [];
}
